import {
    React
} from 'react';
import "../../styles/loginFormStyle.css";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';

function ControlUser(props) {

    const { open, onClose, data } = props;

    const navigate = useNavigate();

    const ControlInfo = () => {
        if (data !== undefined && data.length !== 0) {
            switch (data[0].Confirmado) {
                case "RE":
                    return <p>Uninitialized user, please contact your manager to obtain the initial password</p>;
                case "No":
                    return <p>User blocked in the system, contact your manager to modify their status</p>;
                case "RP":
                    return <p>Your user account requires a mandatory password change</p>;
                case "MF":
                    return <p>Your user requires MFA processing</p>;
                default:
                    return <p>Unknown user status. Please contact your manager.</p>;
            }
        } else {
            return <p>The user doesn`t exist. If you need a user, contact your manager</p>;
        }
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => onClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        overflow: 'hidden',
                        minWidth: 320,
                        boxShadow: '0 30px 70px rgba(0,0,0,0.4), 0 0 0 1px rgba(41,182,246,0.15)',
                    }
                }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{
                        backgroundColor: '#1565c0',
                        borderBottom: '3px solid #29b6f6',
                        color: '#ffffff',
                        textAlign: 'center',
                        fontWeight: 700,
                        letterSpacing: '1px',
                    }}
                >
                    {"User"}
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center', paddingTop: '20px !important' }}>
                    <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center', color: '#1a2744' }}>
                        {ControlInfo()}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default ControlUser; 